<template>
  <div>
    <div v-if="this.loading" class="text-center">
      <b-spinner
        label="Loading..."
        variant="secondary"
        class="mt-5 mx-center"
      ></b-spinner>
    </div>
    <div v-else-if="this.loggedUser">
      <b-navbar type="dark" variant="dark" sticky>
        <b-navbar-nav>
          <b-nav-item :to="{ name: 'setup' }">Setup</b-nav-item>
          <b-nav-item :to="{ name: 'fraud' }">Fraud</b-nav-item>
          <b-nav-item :to="{ name: 'engagement' }">Engagement</b-nav-item>
          <b-nav-item v-if="this.loggedUser.displayName !== 'external'" :to="{ name: 'audience' }">Audience Builder</b-nav-item>
          <b-nav-item v-if="this.loggedUser.displayName === 'admin'" :to="{ name: 'voluum' }">Voluum</b-nav-item>
          <b-nav-item :to="{ name: 'insights' }">Insights</b-nav-item>
          <b-nav-item
            v-if="this.loggedUser.displayName === 'admin'"
            :to="{ name: 'admin' }"
            >Admin</b-nav-item
          >
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-form v-if="this.loggedUser.displayName === 'admin'">
            <b-form-group>
              <b-form-radio-group
                v-model="abSelected"
                :options="abOptions"
                name="ab-selector"
                size="sm"
                buttons
                button-variant="outline-secondary"
                @change="this.selectAB"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-input
              v-model="demoUid"
              size="sm"
              class="ml-2"
              placeholder="Enter uid"
            ></b-form-input>
            <b-button
              :variant="this.demoState"
              size="sm"
              class="ml-2 mr-3"
              @click="this.enterDemoMode"
              >Demo</b-button
            >
          </b-nav-form>
          <b-nav-item-dropdown right :text="this.loggedUser.email">
            <b-dropdown-item @click="signOut" href="#"
              >Sign Out</b-dropdown-item
            >
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-navbar>
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
    <div
      v-show="!this.loading && !this.loggedUser"
      class="my-5 py-5 container-fluid"
      id="firebaseui-auth-container"
    ></div>
  </div>
</template>

<script>
import { firebaseConfig } from "./firebaseConfig";
export default {
  name: "App",
  data() {
    return {
      loading: true,
      loggedUser: null,
      abOptions: ["A", "B"],
      abSelected: "A",
      demoUid: "",
      demoState: "secondary",
    };
  },
  methods: {
    signOut() {
      firebase
        .auth()
        .signOut()
        .catch((error) => {
          console.error(error);
        });
    },
    enterDemoMode() {
      if (this.demoUid !== "" || this.demoState === "success") {
        this.$store.commit("setDemoUid", this.demoUid);
      }
      this.demoUid === ""
        ? (this.demoState = "secondary")
        : (this.demoState = "success");
    },
    selectAB() {
      this.$store.commit("setAB", this.abSelected);
    },
  },
  created() {
    firebase.initializeApp(firebaseConfig);
    firebase.auth().onAuthStateChanged((user) => {
      this.loggedUser = user;
      this.loading = false;
    });

    var uiConfig = {
      signInSuccessUrl: "/",
      signInOptions: [
        {
          provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
          signInMethod:
            firebase.auth.EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD,
          disableSignUp: {
            status: true,
            adminEmail: "todor@adcash.com",
          },
        },
      ],
    };
    var ui = new firebaseui.auth.AuthUI(firebase.auth());
    ui.start("#firebaseui-auth-container", uiConfig);
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue